import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const DownArrowIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="none"
        viewBox="0 0 32 32"
    >
        <path
            fill="#343B47"
            d="M23.648 12.3443a1.1573 1.1573 0 0 1 0 1.6623l-6.7982 6.6491c-.4693.4591-1.2303.4591-1.6996 0L8.352 14.0066a1.1573 1.1573 0 0 1 0-1.6623c.4693-.4591 1.2302-.4591 1.6995 0L16 18.1623l5.9485-5.818c.4693-.4591 1.2302-.4591 1.6995 0Z"
        />
    </svg>
);